
<!-- THIS COMPONENT IS BASED FROM: https://github.com/andrewcourtice/vuetiful/tree/master/src/components/datatable -->
<template>
<div class="app-datatable table-wrapper" :class="tableClasses">
  <div class="datatable-options">
    <slot name="options"></slot>
    <div class="index-heading">
      <div v-if="filterable" class="search-container">
        <input type="text" id="search-box" class="search-box" placeholder="Press enter to search..." v-model="filter" self="size-x1" v-if="searchCallback" v-on:keyup.enter="searchCallback(filter)">
        <input type="text" id="search-box" class="search-box" placeholder="Search..." v-model="filter" self="size-x1" v-else>

        <label v-if="!filter" for="search-box" class="fa fa-search"></label>
        <label v-else for="search-box" class="icon far fa-times" @click="clearSearch"></label>

      </div>
      <div v-else class="search-container">
        <h1></h1>
      </div>
      <slot name="searchLeft"></slot>
    </div>
  </div>

  <div v-if="isLoading" id="datatable-loading-indicator">
    <span class="fa fa-spinner fa-spin" aria-hidden="true"></span>
  </div>

  <table>
    <thead class="datatable-columns">
      <slot></slot>
    </thead>

    <tbody class="datatable-body">
      <tr v-if="displayRows.length < 1"
          class="empty-row odd">
        <td :colspan="columnSpan">
          {{isLoading ? "Loading..." : message}}
        </td>
      </tr>
      <slot v-else
            name="source_template"
            v-for="(row, index) in displayRows"
            :row="row"
            :classObj="{'odd': (index + 1) % 2 === 1, 'even': (index + 1) % 2 === 0}">
      </slot>
    </tbody>
    <tfoot class="datatable-footer" >
      <slot name="tfoot"></slot>
    </tfoot>
  </table>

  <paginator v-if="paginate" ref="paginator" :source="rows"></paginator>
</div>
</template>

<script>
/* eslint-disable */
import Paginator from "@/components/Datatables/AppPaginator";
import _ from 'lodash'

export default {
  components: {
    "paginator": Paginator
  },
  
  props: {
    
    searchCallback: {
      type: Function,
      default: () => {
        return null
      }
    },
    
    fixed: {
      type: Boolean,
      default: true
    },
    
    source: {
      type: Array,
      default: () => []
    },
    
    editable: {
      type: Boolean,
      default: false
    },
    
    filterable: {
      type: Boolean,
      default: true
    },
    
    threshold: {
      type: Number,
      default: 500
    },
    
    message: {
      type: String,
      default: "No results"
    },
    
    isLoading: {
      type: Boolean,
      default: false
    },
    
    paginate: {
      type: Boolean,
      default: true
    }
    
  },
  
  data() {
    return {
      columns: [],
      filter: null,
      sortingId: null
    };
  },
  
  computed: {
    
    sortingColumn() {
      return this.columns.find(column => column.id === this.sortingId);
    },
    
    tableClasses() {
      return {
        "datatable-editable": this.editable,
        "table-fixed": this.fixed
      };
    },
    
    rows() {
      let rows = this.source;
      
      /**
       * Feel free to remove the eventBus.
       * currently is specifically used to communicate to child components (AppExpandingRow.vue)
       *
       * put events on the event bus to listen and push events independent of component hierarchy
       * window.eventBus = new Vue({}); ( put this globally if want to use )
       * -- Tyler
       */
      if ( eventBus ) {
        eventBus.$emit('datatable-filtering'); // NAE project use case specific right now.
      }

      // Filter the rows first to reduce the set (if a filter is supplied) we need to sort
      if ( this.filter ) {
        let searchable_properties = _.compact(this.columns.map(function(column) {
          if( column.isSearchable() ) {
            return column.getSearchKey();
          }
        }));
        rows = this.filterBy(this.filter, rows, searchable_properties);
      }

      // Sort the filtered set
      if ( this.sortingColumn ) {
        rows = this.sortBy(rows, this.sortingColumn.getSortKey(), this.sortingColumn.sortingDirection);
      }

      return rows;
    },

    displayRows() {
      let display = this.rows;

      if ( this.paginate && this.$refs.paginator ) {
        display = this.$refs.paginator.data || [];
      }

      return display;
    },

    optimize() {
      return false
    },

    columnSpan() {
      return this.columns.length;
    }
  },

  methods: {

    addColumn(column) {
      this.columns.push(column);
    },

    removeColumn(column) {
      let index = this.columns.indexOf(column);
      this.columns.splice(index, 1);
    },

    clearSearch() {
      this.filter = "";
    },

    filterBy(filter, array, searchable_properties) {
      // const SEARCHABLE_TYPES = ["string", "number", "boolean"];
      if (!filter) {
        return array;
      }
      return array.filter((row) => {
        let allText = _.map(this.columns, (col) => row[col.id]).join('').toLowerCase()
        return _.split(filter, " ").every((fragment) => {
          return allText.indexOf(fragment.toLowerCase()) > -1;
        })
        
      })
    },
      
    //   let filtered = [];
    //   searchable_properties = _.compact(searchable_properties);
    //   for (let i = 0; i < array.length; i++) {
    //     let item = array[i];
    //     var searchable_values = [];

    //     for (let j = 0; j < searchable_properties.length; j++) {
    //       let property = searchable_properties[j];
    //       let v = this.accessObjPropertyByString(item, property);
    //       searchable_values.push(v);
    //     }
    //     searchable_values = _.compact(searchable_values);

    //     for (let k = 0; k < searchable_values.length; k++) {
    //       let value = searchable_values[k];
    //       // Ensure the value is of a searchable type
    //       // This will automatically handle null values
    //       if ( SEARCHABLE_TYPES.indexOf(typeof (value)) < 0 ) {
    //         continue;
    //       }

    //       // Normalise the value to get a consistent match
    //       let normalized = value.toString().toLowerCase();

    //       if (normalized.indexOf(filter.toLowerCase()) > -1) {
    //         filtered.push(item);
    //         break;
    //       }
    //     }
    //   }

    //   return filtered;
    // },

    sortBy(array, property, direction) {
      direction = direction || 1;

      if (Math.abs(direction) !== 1) {
        throw new Error("Sort direction must be either 1 (ascending) or -1 (descending)");
      }

      let sortArray = [...array];
      let self = this;
      sortArray.sort((a, b) => {
        let valueA = self.accessObjPropertyByString(a, property);
        let valueB = self.accessObjPropertyByString(b, property);

        let outcome = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;

        return outcome * direction;
      });

      return sortArray;
    },

    accessObjPropertyByString(obj, string) {
      string = string.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
      string = string.replace(/^\./, '');           // strip a leading dot
      var array = string.split('.');
      for (var i = 0, n = array.length; i < n; ++i) {
        var k = array[i];
        if (k in obj) {
          obj = obj[k];
        } else {
          return;
        }
      }
      return obj;
    }
  },
}
</script>

<style lang="scss">
@import 'mixins';
// @import 'variables_app_datatables';
@import '../../style/variables';


  .app-datatable {
    &.table-wrapper {
      padding: 0 1.5rem;
    }
    .index-heading {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 0;
      .search-container {
        width: 400px;
        position: relative;
        label {
          position: absolute;
          right: 0;
          bottom: .5em;
          &.fa {
            color: $chc-purple;
          }
        }
      }
    }
    #datatable-loading-indicator {
      font-size: 1.5rem;
      text-align: center;
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(250,250,250,0.5);
      z-index: 1001;

      span {
          position: relative;
          top: 100px;
      }
    }
  }
  .modal .app-datatable {
    padding: 0;
  }
  .make-payment .app-datatable table,
  .payment-details .app-datatable table {
    width: 80vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/Datatables/AppDatatable.vue